import { type CheckboxGroupProps as CheckboxGroupPrimitiveProps } from "react-aria-components";

import * as S from "./CheckboxGroupBaseV2.styled";

export type CheckboxGroupBaseV2Props = CheckboxGroupPrimitiveProps;

function CheckboxGroupBaseV2(props: CheckboxGroupBaseV2Props) {
  return <S.CheckboxGroup {...props} />;
}

export default CheckboxGroupBaseV2;
